export enum FormActions {
  Create,
  Edit,
  Duplicate,
  View
}
